import React from 'react';
import registeredComponent from "utils/registeredComponent";
import {duckify, filterDuck} from "utils/duckify";
import ModalComponent from './ModalComponent';
import {bulkActionEvents} from "ducks";
import Placeholder from "components/Placeholder";
import './styles/bulk_action_event.scss';


class BulkActionEventModal extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    const {bulkActionEvents, name} = this.props;
    const eventTypes = {'data_retention': <DataRetentionAudits events={bulkActionEvents}/>};
    return (<ModalComponent title="Audit Log">
      <Placeholder.loading ready={bulkActionEvents.ready}>
        {bulkActionEvents.length > 0 ? <div>{eventTypes[name]}</div> : <div> No audits exist at this time. </div>}
      </Placeholder.loading>
    </ModalComponent>)
  }
}

// Ideally, if we got more types of bulk action events with metadata, we could create more
// functional components to render that data

const DataRetentionAudits = ({events}) => {
  return( < div className={'event-container'}>
      <h2>Data Retention Audits</h2>
        <div className={'event-row'}>
          <span className={'event-item'}>Run At</span>
          <span className={'event-item'}>Year</span>
          <span className={'event-item'}>User</span>
          <span className={'event-item'}>Review Data</span>
          <span className={'event-item'}>Checklist Items</span>
        </div>

          <span className={'line'}/>
        {events.map((event) =>
          <div className={'event-row'}>
            <span className={'event-item'}>{event.created_at}</span>
            <span className={'event-item'}>{event.metadata.year.name}</span>
            <span className={'event-item'}>{event.user_name}</span>
            <span className={'event-item'}>{event.metadata.review_data ? "Removed" : ""}</span>
            <span className={'event-item'}>{event.metadata.items.map((item) => <ul className={'event-list'}>{item}</ul>)}</span>
          </div>
        )}

  </div>)
};


function mapDucksToProps(props) {
  const name = props.name;
  return {
    bulkActionEvents: filterDuck(bulkActionEvents, {name: name})
  }
}

export default registeredComponent("BulkActionEventModal")(duckify(mapDucksToProps)(BulkActionEventModal))
